export default "__VITE_ASSET__DynB$Lw8__"